









import Vue from "vue";
import { Component } from "vue-property-decorator";
import UserSettingsSidebar from "@/components/settings/sidebar.vue";

@Component({
  components: {
    "uc-user-settings-sidebar": UserSettingsSidebar,
  },
})
export default class UserDetail extends Vue {
  visible = true;
}
